import type { TVDLLayoutState } from '@VDL/types/VDLLayoutState';

export const DEBUG_GRAPH_TABLE_EDIT = false;

export const INITIAL_PAGE_STATE: TVDLLayoutState = {
  code: 'initial',
  type: 'default',
  title: null,
  unresolvedURL: null,
  resolvedURL: null,
  isEdit: false,
  haveBackButton: false,
  isNotEditable: true
};

export const SHOW_AGREEMENT = false;